import React from 'react'
import './FormError.scss'

const FormError = ({ errorString }) => {
  return (
    <>
      <div className='form-error red white-bck'>
        <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
        {errorString}
      </div>
    </>
  )
}

export default FormError